import { Drawer } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import {
  useCommonContext,
  usePurchaseHistoryContext,
} from '../../../../hooks/useContexts';
import { IAddReceiptDrawer } from '../../../../models/purchase-history/add-receipt';
import {
  InStoreReceiptForm,
  OnlineReceiptForm,
  ReceiptScanner,
  SelectReceiptType,
} from './index';

export const AddReceiptDrawer = ({
  closeDrawer,
  isDrawerOpen,
  svocId = '',
}: IAddReceiptDrawer) => {
  const { isMobile } = useCommonContext();
  const { setAlertState } = usePurchaseHistoryContext();
  const mobileView = isMobile ? 0 : 1;
  const [drawerStepper, setDrawerStepper] = useState<number>(mobileView);

  const closeReceiptDrawer = () => {
    closeDrawer();
    setTimeout(() => {
      setDrawerStepper(mobileView);
    }, 500);
  };

  const generateReceiptType = () => {
    switch (drawerStepper) {
      case 0:
      case 1:
        return (
          <SelectReceiptType
            closeDrawer={closeReceiptDrawer}
            drawerStepper={drawerStepper}
            setDrawerStepper={setDrawerStepper}
          />
        );
      case 2:
        return (
          <InStoreReceiptForm
            closeDrawer={closeReceiptDrawer}
            setAlertState={setAlertState}
            setDrawerStepper={setDrawerStepper}
            svocId={svocId}
          />
        );
      case 3:
        return (
          <OnlineReceiptForm
            closeDrawer={closeReceiptDrawer}
            setAlertState={setAlertState}
            setDrawerStepper={setDrawerStepper}
            svocId={svocId}
          />
        );
      case 4:
        return (
          <ReceiptScanner
            closeDrawer={closeReceiptDrawer}
            setAlertState={setAlertState}
            setDrawerStepper={setDrawerStepper}
            svocId={svocId}
          />
        );
      default:
        break;
    }
    return null;
  };

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={closeReceiptDrawer}
      style={{ zIndex: 2000000008 }}
    >
      {generateReceiptType()}
    </Drawer>
  );
};
